import type { PartialRibbonConfiguration } from './combineConfigStores';
import { getRibbonSectionContents } from './getRibbonSectionContents';
import { type ActionControlId } from 'owa-ribbon-ids/lib/actionControlId';
import { type HelpRibbonControlId, type HelpRibbonGroupId } from 'owa-ribbon-ids/lib/helpControlId';
import { type MailRibbonControlId, type MailRibbonGroupId } from 'owa-ribbon-ids/lib/mailRibbonId';

export const win32Config: PartialRibbonConfiguration = {
    multiline: {
        homeTab: {
            layout: [
                getRibbonSectionContents(116, [587, 586]),
                getRibbonSectionContents(104, [531, 658, 519, 683, 684, 505]),
                getRibbonSectionContents(197, [657]),
                getRibbonSectionContents(192, []),
                getRibbonSectionContents(121, [556, 557, 555, 678, 696, 553, 698, 686, 712]),
                getRibbonSectionContents(198, [731, 709]),
                getRibbonSectionContents(195, [697]),
                getRibbonSectionContents(120, [550]),
                getRibbonSectionContents(113, [572, 540, 559]),
                getRibbonSectionContents(128, [616, 552, 509, 527, 548, 571]),
                getRibbonSectionContents(118, [549]),
                getRibbonSectionContents(101, [529, 7016, 7022]),
                getRibbonSectionContents(108, [663, 508]),
                getRibbonSectionContents(130, [580]),
            ],
            staticGroupIdOrdering: [
                116, 104, 197, 192, 121, 198, 195, 120, 113, 128, 118, 101, 108, 130,
            ],
        },
        helpTab: {
            layout: [
                getRibbonSectionContents(11001, [11201, 11202, 11203]),
                getRibbonSectionContents(11002, [11208, 11204, 11205]),
            ],
        },
    },
    singleline: {
        homeTab: {
            layout: [
                getRibbonSectionContents(114, [587, 519, 683, 684, 505, 657, 658, 572, 540, 559]),
                getRibbonSectionContents(192, []),
                getRibbonSectionContents(121, [556, 557, 555, 678, 696, 553, 698, 686, 712]),
                getRibbonSectionContents(198, [731, 709]),
                getRibbonSectionContents(195, [697]),
                getRibbonSectionContents(128, [550, 616, 552, 509, 527, 548, 571]),
                getRibbonSectionContents(118, [549]),
                getRibbonSectionContents(101, [529, 7022, 7016]),
                getRibbonSectionContents(108, [663, 508]),
                getRibbonSectionContents(130, [580]),
                getRibbonSectionContents(122, [558]),
            ],
            staticGroupIdOrdering: [114, 192, 121, 198, 195, 128, 130, 118, 101, 108],
        },
        helpTab: {
            layout: [
                getRibbonSectionContents(11001, [11201, 11202, 11203]),
                getRibbonSectionContents(11002, [11208, 11204, 11205]),
            ],
        },
    },
};
